import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "./MarkersMap.css";
import marker from "../../assets/img/marker.png";

const MarkersMap = () => {
  const position = [37.853533769972834, -75.56214474502111];
  // const position1 = [51.65097570826511, 0.23004418697519616];
  // const position2 = [51.34148012626598, -0.7340060440183735];
  // const position3 = [51.58787949774656, -0.34948458436281904];
  // const position4 = [51.43420636926504, 0.004697293042703278];

  const markerIcon = L.icon({
    iconUrl: marker,
    iconSize: [35, 40],
    iconAnchor: [10, 30],
    popupAnchor: [0, -10],
    shadowAnchor: [10, 10],
  });

  return (
    <>
      <MapContainer
        style={{ widht: "100%", height: "40em" }}
        center={position}
        zoom={13}
        scrollWheelZoom={false}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Marker icon={markerIcon} position={position}>
          <Popup>Qua Logistics</Popup>
        </Marker>
        {/* <Marker icon={markerIcon} position={position1}>
          <Popup>Qua Logistics</Popup>
        </Marker>
        <Marker icon={markerIcon} position={position2}>
          <Popup>Qua Logistics</Popup>
        </Marker>
        <Marker icon={markerIcon} position={position3}>
          <Popup>Qua Logistics</Popup>
        </Marker>
        <Marker icon={markerIcon} position={position4}>
          <Popup>Qua Logistics</Popup>
        </Marker> */}
      </MapContainer>
    </>
  );
};

export default MarkersMap;
